<template>
    <div :class="['sal-accordion', show ? 'open': '']">
        <div :class="['sal-accordion--header']" @click="toggle">
            <div :class="['icon-toggle', show ? 'minus': 'plus']">
                <span class="vertical"></span>
                <span class="horizontal"></span>
            </div>
            <slot name="header"></slot>
        </div>
        <div class="sal-accordion--body" v-show="show">
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
    import {constants} from "@productfinder/shared/constants";

    export default {
        name: "sal-accordion",
        props: {
            initOpen: false
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            toggle() {
                this.show = !this.show;
                if (this.show) {
                    this.$store.dispatch('setBackground', { background: constants.background.light });
                } else {
                    this.$store.dispatch('setBackground', { background: "" });
                }

            }
        },
        created() {
            if (!this.show && this.initOpen) {
                this.toggle();
            }
        }
    }
</script>
